import { Button, Col, Form, Select, Row } from "antd";
import { endOfDay, format, startOfDay } from "date-fns";
import moment from "moment";
import FloatDatePicker from "../../../common/components/FloatDatePicker";
import FloatInput from "../../../common/components/FloatInput";
import FloatSelect from "../../../common/components/FloatSelect";
import { PrepaySearch } from "../../types";

const { Option } = Select;

interface FilterProps {
    setSubmitValue: React.Dispatch<React.SetStateAction<PrepaySearch | undefined>>,
    triggerSearch: (submitValue: PrepaySearch) => void,
    setPage: React.Dispatch<React.SetStateAction<number>>,
}

const PrepayFilter = ({ setSubmitValue, triggerSearch, setPage }: FilterProps) => {
    const [form] = Form.useForm();

    const onReset = () => {
        setSubmitValue({});
        setPage(1);
        triggerSearch({ page: 0 });
        form.resetFields();
    }

    const onValuesChange = (changedValues: any, allValues: any) => {
        let toDateValue = form.getFieldValue("toDate");
        if (changedValues.fromDate && toDateValue && changedValues.fromDate > toDateValue) {
            form.setFieldsValue({
                toDate: ""
            })
        }
    }

    const onFinish = (values: any) => {
        let submitValue: PrepaySearch = {
            ...values.productName ? { productName: values.productName.trim() } : {},
            ...values.fromDate ? { tradingFromDate: format(startOfDay(values.fromDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.toDate ? { tradingToDate: format(endOfDay(values.toDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.productCode ? { productCode: values.productCode.trim() } : {},
            ...!Number.isNaN(values.status) ? { tradingStatus: values.status } : {},
            page: 0,
        }
        setSubmitValue(submitValue);
        setPage(1);
        triggerSearch(submitValue);
    }

    const disabledDate = (date: moment.Moment) => {
        return (date && date < moment(0))
    }

    return (
        <Form
            className="custom-form"
            name="register"
            form={form}
            colon={false}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            style={{ background: 'white', padding: 15, borderRadius: 15 }}
        >
            <div className="font-size-16 font-bold">Tên tài sản</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="productName"
                        style={{ marginBottom: 0 }}>
                        <FloatInput label="" placeholder="Nhập tên tài sản" className="filter-input" allowClear maxLength={200} />
                    </Form.Item>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Mã tài sản</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="productCode"
                        style={{ marginBottom: 0 }}>
                        <FloatInput label="" placeholder="Nhập mã tài sản" className="filter-input" allowClear maxLength={50} />
                    </Form.Item>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Thời gian giao dịch</div>
            <Row style={{ marginTop: 5 }} gutter={10}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="fromDate"
                        style={{ marginBottom: 0 }}>
                        <FloatDatePicker label="" placeholder="Từ ngày" className="filter-picker" disabledDate={disabledDate} allowClear />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="toDate"
                        style={{ marginBottom: 0 }}>
                        <FloatDatePicker
                            allowClear
                            label=""
                            placeholder="Đến ngày"
                            className="filter-picker"
                            disabledDate={(current) => {
                                return current && current < form.getFieldValue("fromDate") && current < moment(0)
                            }} />
                    </Form.Item>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Trạng thái giao dịch</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="status"
                        style={{ marginBottom: 0 }}>
                        <FloatSelect
                            allowClear
                            label=""
                            placeholder="Lựa chọn"
                            className="custom-select filter-select">
                            <Option value={1}>Chờ đối soát</Option>
                            <Option value={2}>Xác nhận nộp tiền đặt trước</Option>
                            <Option value={3}>Không xác nhận nộp tiền đặt trước</Option>
                        </FloatSelect>
                    </Form.Item>
                </Col>
            </Row>

            <Row style={{ marginTop: 30 }} align="middle" gutter={10}>
                <Col span={12}>
                    <Button className="button-gray" style={{ height: 45 }} block onClick={onReset}>NHẬP LẠI</Button>
                </Col>
                <Col span={12}>
                    <Button className="button-light-yellow" style={{ height: 45 }} block htmlType="submit">TÌM KIẾM</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default PrepayFilter;